import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createPortal } from 'react-dom';
import { forwardRef, memo } from 'react';
import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { optionsDiv } from '../Select/Options';
import css from './Options.module.scss';
import toGlobalID from '../../utils/toGlobalID';
/* eslint-disable react/no-array-index-key */

import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var Options = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var left = _ref.left,
      onChange = _ref.onChange,
      open = _ref.open,
      options = _ref.options,
      top = _ref.top,
      value = _ref.value;
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.on, open)]),
    ref: ref,
    style: {
      left: left,
      top: top
    },
    children: /*#__PURE__*/_jsx("div", {
      className: css.list,
      role: "listbox",
      tabIndex: open ? 0 : -1,
      children: options.map(function (option, idx) {
        var id = toGlobalID(option.id);
        var buttonProps = {
          'aria-label': option.ariaLabel ? option.ariaLabel : "Select ".concat(option.title),
          className: css.button,
          onClick: function onClick() {
            onChange(id);
          },
          role: 'option'
        };

        if (option.value === value) {
          buttonProps['aria-selected'] = true;
        }

        return /*#__PURE__*/_createElement("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
          key: "".concat(option.value, "-").concat(idx),
          type: "button"
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.img, _defineProperty({}, css.on, value === id)]),
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, option.image), {}, {
            alt: option.title,
            sizes: [24],
            wrap: false
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: css.title,
          children: option.title
        }));
      })
    })
  }), optionsDiv());
});
Options.propTypes = {
  left: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  top: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool, PropTypes.number, PropTypes.string])
};
export default /*#__PURE__*/memo(Options);